import { FC } from 'react';
import { Tag } from 'primereact/tag';
import { LogicalOperator } from '../../models/expression';

interface LogicalOperatorChipProps {
  operator: LogicalOperator;
  className?: string;
}

export const LogicalOperatorChip: FC<LogicalOperatorChipProps> = ({ 
  operator,
  className = '',
}) => {
  const text = operator === LogicalOperator.And ? 'AND' : 'OR';
  
  return (
    <Tag
      value={text}
      className={className}
      style={{
        fontSize: '0.7rem',
        padding: '0.15rem 0.4rem',
        fontWeight: 600,
        minWidth: '2.5rem',
        textAlign: 'center',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#9333ea',
        color: 'white',
        height: '1.5rem',
      }}
    />
  );
};
